import {Injectable} from '@angular/core';
import * as $ from 'jquery';

// Photos Google : https://lh3.googleusercontent.com/<id>=rw-w700-h660-l80
// Ce qui suit le "=" est une demande de redimensionnement (non signée, sans expiration ;
// l'identifiant, lui, reste valide). Quand la taille demandée dépasse le master que Google
// détient, certaines images sont rabotées et renvoyées en 200, d'autres refusées en 403 : ce
// n'est pas lisible dans l'URL, seul l'essai le dit.
// L'URL nue répond toujours, mais plafonnée à ~512 px sur le grand côté : elle sert de repli,
// jamais de forme normalisée — couper le suffixe partout diviserait par deux la résolution de
// toutes les photos qui ont un vrai master.
const GOOGLE_RESIZED_PICTURE = /^(https:\/\/lh\d+\.googleusercontent\.com\/[^=?]+)=/;

@Injectable({
    providedIn: 'root'
})
export class ImageService {

    // URL de repli d'une image en échec, null s'il n'y en a pas (URL déjà nue, autre hébergeur).
    fallbackUrl(url: string): string {
        const match = GOOGLE_RESIZED_PICTURE.exec(url || '');
        return match ? match[1] : null;
    }

    /**
     * Handler (error) des <img> de photos d'annonce : on réessaie d'abord sans la demande de
     * taille. Sans repli possible, on retombe sur le comportement historique — vendu.png et
     * classe 'sell' sur la carte, pour la 1re photo uniquement et si la carte est identifiée.
     * La boucle se termine d'elle-même : l'URL nue ne matche plus la regex, donc un 2e échec
     * passe directement par le cas "vendu".
     */
    changeImg(event, i = null, id = null) {
        const img = event.target;
        const fallback = this.fallbackUrl(img.src);

        if (fallback) {
            img.src = fallback;
            // Sur les cartes d'annonce, la photo visible est le background du carousel-item et
            // le <img> n'est qu'une sonde cachée : il faut basculer le background avec lui.
            const parent = img.parentElement;
            if (parent && parent.style.backgroundImage) {
                parent.style.backgroundImage = 'url(' + fallback + ')';
            }
            return;
        }

        if (i === 0 && id !== null) {
            img.src = 'assets/vendu.png';
            $('.card-' + id).addClass('sell');
        }
    }
}
